export const floatlabel = {
  root: {
    class: [
      'group/float-label min-w-0',
      '[&>*:last-child]:max-w-[calc(100%-1.75rem)]',
      '[&>*:last-child]:truncate',
      '[&>*:last-child]:after:absolute',
      '[&>*:last-child]:after:inset-[50%_0_0_0]',
      '[&>*:last-child]:after:-z-10',
      // Niet alle prime vue componenten hebben een echt input component
      // Daarom hier ook op basis van role zoeken.
      // NB (tailwind v4): de has-conditie hoort bij de root en staat daarom vóór de
      // [&>*:last-child]-verschuiver; v3 stapelde varianten in omgekeerde volgorde.
      'has-[[role=combobox],input,textarea]:[&>*:last-child]:after:bg-white',
      'grow',
      'flex relative',

      // Base Label Appearance
      '[&>*:last-child]:text-grey-400',
      '[&>*:last-child]:absolute',
      '[&>*:last-child]:top-1/2',
      '[&>*:last-child]:-translate-y-1/2',
      'has-[[role=combobox],input,textarea]:[&>*:last-child]:left-3',
      '[&>*:last-child]:pointer-events-none',
      '[&>*:last-child]:transition-all',
      '[&>*:last-child]:duration-200',
      '[&>*:last-child]:ease',
      'has-[.text-xs]:[&:not(:has(.filled,:focus,:placeholder-shown))>*:last-child]:text-xs',
      'has-[.text-xl]:[&:not(:has(.filled,:focus,:placeholder-shown))>*:last-child]:text-xl',

      // Focus Label Appearance
      'has-focus:[&>*:last-child]:-top-0.5',
      'has-focus:[&>*:last-child]:left-3.5',
      'has-focus:[&>*:last-child]:px-[.1875rem]',
      'has-focus:[&>*:last-child]:text-xs',
      'has-focus:[&>*:last-child]:text-grey-600',

      // Filled Input Label Appearance
      'has-[.filled]:[&>*:last-child]:-top-0.5',
      'has-[[role=combobox],input,textarea]:[&>*:last-child]:left-3.5',
      'has-[[role=combobox],input,textarea]:[&>*:last-child]:px-[.1875rem]',
      'has-[.filled]:[&>*:last-child]:text-xs',
      'has-[.filled]:[&>*:last-child]:text-grey-600',

      // Placeholder Label Appearance
      'has-placeholder-shown:[&>*:last-child]:-top-0.5',
      'has-placeholder-shown:[&>*:last-child]:left-3.5',
      'has-placeholder-shown:[&>*:last-child]:px-[.1875rem]',
      'has-placeholder-shown:[&>*:last-child]:text-xs',
      'has-placeholder-shown:[&>*:last-child]:text-grey-600',

      // Disabled Label Appearance
      'has-[[role=combobox],input,textarea]:has-[:disabled,[aria-disabled="true"]]:[&>*:last-child]:after:bg-grey-50',
    ],
  },
};
